// client/src/components/layout/AppBackground.tsx
import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';

interface AppBackgroundProps {
  children: ReactNode;
}

/**
 * AppBackground component applies the landing page gradient background
 * to any content wrapped within it
 */
const AppBackground: React.FC<AppBackgroundProps> = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        fontFamily: '"Inter", sans-serif',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  );
};

export default AppBackground;
